import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as history from "app/main/history";
import * as resources from "app/resources/index";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { RxfyScalar, componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";
import { Observable } from "rxjs";
import { DireccionClienteEdit } from "app/features/general/catalogos/items/clientes/edit/componentes/tabs/direcciones/edit";


export interface DireccionSelectorElement {
    /**Id del selector */
    id: number;
    /**Datos que se le van a mostrar al usuario */
    view: models.DireccionDTO;
}


class DireccionElement extends React.PureComponent<{ value: models.DireccionDTO }> {
    render() {
        const x = this.props.value;
        return (
            <div>
                <span>
                    <i className={fa("street-view", "fw")} />
                    <label>{x.Calle} #{x.NoExterior}</label>, col. {x.NombreColonia}
                </span>
                <br />
                <span>
                    <i className={fa("map-o", "fw")} />
                    {x.NombreCiudad || x.NombreMunicipio}, {x.NombreEstado}
                </span>
            </div>
        )
    }
}

interface ViewProps {
    idCliente?: number | null;
    items: DireccionSelectorElement[];
    value?: number | null;
    onChange?: (x: number | null) => void;
    readonly?: boolean;
    loading?: boolean;
    error?: Observable<boolean | string | undefined> | boolean | string;
    label?: string;
}


class DireccionSelectorView extends React.PureComponent<ViewProps> {
    modalManager = kea.createModalManager();

    onAgregar = async () => {
        const idCliente = this.props.idCliente;
        if (!idCliente) return;
        const result = await this.modalManager.showModal(DireccionClienteEdit, {}, { IdCliente: idCliente, Contactos: [] } as any as models.DireccionCliente);
        if (result.result == true) {
            const cliente: models.Cliente = await resources.Cliente.get(idCliente);
            await resources.DireccionCliente.add(result.value);
            const nuevoCliente: models.Cliente = await resources.Cliente.get(idCliente);
            const id = nuevoCliente.Direcciones.map(x => x.IdRegistro).reduce((a, b) => Math.max(a, b));
            this.props.onChange && this.props.onChange(id);
        }
    }

    render() {
        const items = this.props.items ? this.props.items.map<kea.SelectorElement>(x => ({
            label: x.view.Descripcion,
            value: x.id,
            view: <DireccionElement value={x.view} />
        })) : [];

        return (
            <div>
                <kea.Select
                    items={items}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    readonly={this.props.readonly}
                    loading={this.props.loading}
                    error={this.props.error}
                    label={this.props.label}
                    onAgregar={this.props.idCliente ? this.onAgregar : undefined}
                />
                {this.modalManager.component}
            </div>
        );
    }
}

/**Selector de direcciones */
export const DireccionSelector = kea.defaultProps(componentToRx(DireccionSelectorView, undefined, undefined, {
    loading: { loading: true },
    error: { ignore: { promise: true, observable: true } },
    items: { initial: [] }
}), { label: "Dirección" });


// WEBPACK FOOTER //
// ./app/features/selectores/items/direccion.tsx